import styled from 'styled-components';
import { breakpoints } from '@exo/frontend-common-theme-utils';
import theme from './Error.theme';

export const Error = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: ${props => theme(props).pageMargin};
  padding: ${props => theme(props).pagePadding};
  width: 100%;

  /* stylelint-disable */
  & .errorClass {
    margin: ${props => theme(props).headerMargin};

    & h1 {
      font: ${props => theme(props).errorHeaderMobile};
      text-align: center;
      ${breakpoints.greaterThan('small')`
        font: ${props => theme(props).errorHeader};
      `}
    }
  }
  /* stylelint-enable */
`;

export const ErrorReason = styled.div`
  color: ${props => theme(props).errorReasonColor};
  margin: ${props => theme(props).errorMessageMargin};
`;

export const Icon = styled.div`
  margin: ${props => theme(props).iconMargin};

  /* stylelint-disable-next-line */
  & svg {
    color: ${props => theme(props).errorIconColor};
    height: ${props => theme(props).errorIconDimensionMobile};
    width: ${props => theme(props).errorIconDimensionMobile};
  }

  ${breakpoints.greaterThan('small')`
    & svg{
      height: ${props => theme(props).errorIconDimension};
      width: ${props => theme(props).errorIconDimension};
    }
  `}
`;
export const Message = styled.div`
  font: ${props => theme(props).messageFont};
  margin: ${props => theme(props).errorMessageMargin};
  text-align: center;

  & .link {
    color: ${props => theme(props).linkColor};
    display: inline;
    font: ${props => theme(props).messageFont};
    margin: ${props => theme(props).linkMargin};
  }

  ${breakpoints.greaterThan('small')`
      width: 40vw;
  `}
`;

export const Link = styled.span`
  color: ${props => theme(props).linkColor};
`;

export const Button = styled.div`
  margin: ${props => theme(props).buttonMargin};
  min-width: ${props => theme(props).buttonWidth};

  /* stylelint-disable */
  & .secondaryButton {
    width: 100%;
  }
  /* stylelint-enable */
`;
